export default "__VITE_ASSET__CkP2lfZH__"